/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Source_Qty_LabelInputs */

const vi_sl_new_source_qty_label = /** @type {(inputs: Sl_New_Source_Qty_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kg lấy từ phiếu cân`)
};

/**

* @param {Sl_New_Source_Qty_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_source_qty_label = /** @type {((inputs?: Sl_New_Source_Qty_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Source_Qty_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_source_qty_label(inputs)
});